<script lang="ts" setup>
import { Button, Icon } from '@brighterly/lib-lumee-ui'

import { AppModal } from '@shared/ui/modals'

import { useLessonRoomStore } from '../../model/store'
import { trackClassroomEvent } from '../../lib/classroom'
import posterImage from '../images/bg-permissions.png'

defineOptions({
  name: 'LessonRoomPermissionsBlocked',
})

const lessonRoomStore = useLessonRoomStore()
const { isDesktop } = useDevice()

const name = 'blocked_permissions'

const close = (): void => {
  trackClassroomEvent('Popup_close', { name, value: 'close_button' })
  lessonRoomStore.setPermissionsBlocked(false)
}

const openGuides = (): void => {
  trackClassroomEvent('Popup_close', { name, value: 'open_guides' })
  lessonRoomStore.setGuideOpen(true)
  lessonRoomStore.setPermissionsBlocked(false)
}

onMounted(() => {
  trackClassroomEvent('Popup_view', { name, text: 'Lesson is blocked from using your camera or microphone' })
})
</script>

<template>
  <AppModal @close="close">
    <template #topSlot>
      <div class="lesson-room-permissions__hero">
        <img
          class="lesson-room-permissions__poster"
          :src="posterImage"
          alt=""
        >
      </div>
    </template>
    <template #contentSlot>
      <div class="lesson-room-permissions">
        <h5 class="lesson-room-permissions__title btly-text-title-l">
          Lesson is blocked from using your camera or microphone
        </h5>

        <p
          v-if="isDesktop"
          class="lesson-room-permissions__text btly-text-body-l"
        >
          Click the
          <span class="lesson-room-permissions__text-icon">
            <Icon
              name="video-slash"
              size="md"
              color="inherit"
            />
          </span>
          and
          <span class="lesson-room-permissions__text-icon">
            <Icon
              name="microphone-slash"
              size="md"
              color="inherit"
            />
          </span>
          icons in the address bar, choose “Always allow…”, then reload the page.
        </p>
        <p
          v-else
          class="lesson-room-permissions__text btly-text-body-l"
        >
          Open your browser settings for this site, allow Camera and Microphone access, then reload the page.
        </p>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        text="Open device guides"
        fill
        @click="openGuides"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="./LessonRoomPermissionsBlocked.scss" />
